<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column  mu-w-100">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">Groups</h1>

                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group">
                        <router-link :to="CONTEXT_PATH + '/usersgroups/groups/new'">
                            <button class="mcc-button mcc-button--primary" id="addGroupBtn" title="Add group">
                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add group</span>
                            </button>
                        </router-link>
                    </div>
                </section>
            </div>
        </div>
    </div>

    <div class="mcc-container-fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Users & groups</li>
                    <li>Groups</li>
                </ol>
            </nav>
        </div>
        <Drawer ref="customFilter" @reset-filter="resetForm" @apply-filter="submitFilterDialog" title="Group Filters">
          
                <section>
                    <div class="mcc-row">
                        <div class="mcc-col">
                            <form id="formIdd">
                            <div>
                                <div class="mfc-input-wrapper mfc-form-input-container mu-mb-05">
                                    <label for="groupname">Group name</label>
                                    <input type="text" name="groupname" maxlength="50" id="groupname" :pattern="nameRegex" ref="groupname" :value="filterGroupName" @change="filterGroupName = $event.target.value">

                                </div>
                                <div class="mfc-slim-select-wrapper mu-mb-05">
                                    <label for="activeConnection" class=" mu-mb-00">Hierarchy chart</label>
                                    <select class="mfc-slim-select" multiple @change="filterHieChart = $event.target.value" ref="hChartsIds" name="hChartsIds" id="hChartsIds">
                                    </select>
                                </div>
                                <div class="mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                    <fieldset class="mfc-fieldset">
                                        <legend class="mfc-label">
                                            Disabled
                                        </legend>
                                        <div class="mcc-segmented-buttons__list" label="Status" block ref="disabledStatus" name="disabledStatus" id="disabledStatus">
                                            <input type="checkbox" name="Yes" value="deleted" id="yes" @click="filterDisabledState = $event.target.value" :checked="filterDisabledState == 'deleted'">
                                            <label class="mcc-segmented-buttons__button" for="yes">
                                                <span class="mcc-segmented-buttons__label">Yes</span>
                                            </label>
                                            <input type="checkbox" name="no" value="active" id="no" @click="filterDisabledState = $event.target.value" :checked="filterDisabledState == 'active'">
                                            <label class="mcc-segmented-buttons__button" for="no">
                                                <span class="mcc-segmented-buttons__label">No</span>
                                            </label>
                                            <input type="checkbox" name="all" value=" " id="all" @click="filterDisabledState = $event.target.value" :checked="filterDisabledState == ' '">
                                            <label class="mcc-segmented-buttons__button" for="all">
                                                <span class="mcc-segmented-buttons__label">All</span>
                                            </label>
                                        </div>
                                    </fieldset>
                                </div>

                            </div>
                        </form>

                                </div>
                            </div>
                        </section>
                   
                </Drawer>
                <div class="mcc-row">
                    <div class="mcc-col">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-card">
                                <div class="mcc-card__body">
                                    <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                        <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                            <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                            <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(1)'}}</span>
                                        </button>
                                    </div>
                                    <mcc-data-table ref="groupsTable" id="groupsTable"></mcc-data-table>
                                </div>

                    </div>
                </div>

            </div>

        </div>
    </div>
</div>
</template>

<script>
import GroupAPI from "../../../services/GroupAPI";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import Drawer from '../../common/Drawer.vue';
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "GroupList",
    components: {
        Drawer
    },

    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["groups.list"],
            nameRegex: constantMessages.PATTERNS["name"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            currentPageSize: 10,
            updateCall: true,
            showHelpText: false,
            tableObj: null,
            filterGroupName: "",
            filterHieChart: "",
            filterDisabledState: "active",
            groupNameRef: "",
            hieChartRef: "",
            disabledStateRef: "active",
            hierarchies: null,
            updateDialog: false,
            hChartsIds: null,
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        if (this.$route.query.hierarchyId) {
            let hierarchy = this.$route.query.hierarchyId;
            if (hierarchy != "" && hierarchy != null) {
                this.filterHieChart = hierarchy.split(",");
                this.hieChartRef = this.filterHieChart;
                this.disabledStateRef = " ";
                this.filterDisabledState = " ";
            }
        } else if (localStorage.getItem("GroupsList") === "GroupsList") {
            let groupName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_groupName"
            );
            if (groupName != null && groupName != "") {
                this.groupNameRef = groupName;
                this.filterGroupName = groupName;
            }
            let hierarchy = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_hChartsIds"
            );
            if (hierarchy != "" && hierarchy != null) {
                this.filterHieChart = hierarchy.split(",");
                this.hieChartRef = this.filterHieChart;
            }

            let disabledStatus = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_disabledStatus"
            );
            if (disabledStatus != null && disabledStatus != "") {
                this.disabledStateRef = disabledStatus;
                this.filterDisabledState = disabledStatus;
            }
            let pageSizeRef = localStorage.getItem("groupListPageSize");
            if (pageSizeRef != null && pageSizeRef != "") {
                this.currentPageSize = parseInt(pageSizeRef);
            }
            localStorage.removeItem("groupListPageSize");
            localStorage.removeItem("GroupsList");
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_groupName"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_hChartsIds"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_disabledStatus"
            );
            
            this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
        }
        this.initGroupsTable();
        var self = this;
        if (this.$refs.groupsTable.isReady) {
            this.initGroupsTable();
        } else {
            this.$refs.groupsTable.addEventListener("ready", function () {
                self.initGroupsTable();
            });
        }
        this.hChartsIds = new SlimSelect({
            select: '#hChartsIds',
            settings: {
                closeOnSelect: false
            }
        });
        GroupAPI.getNonDeletedHierarchies().then(response => {
            if (response != null) {
                self.hierarchies = response;
                let optionsArr = []
                let option;
                response.forEach(hie => {
                    option = {
                        text: hie.name,
                        value: hie.id
                    }
                    optionsArr.push(option);
                })
                this.hChartsIds.setData(optionsArr)
            }
        });
    },
    methods: {
        getFilterCount() {
            if (this.filterGroupName != "")
                this.filterCount += 1;
            if (this.filterHieChart != "")
                this.filterCount += 1;
            if (this.filterDisabledState != "")
                this.filterCount += 1;
        },
       
        initGroupsTable() {
            var self = this;
            self.updateCall = false;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("groupsTable"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No groups found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            columnSearch: false
                        },
                        groupInChartsCount: {
                            type: "string",
                            title: "Hierarchies",
                            sortable: false,
                            template: '<div class="hierarchyDiv" data-id="{{id}}">{{groupInChartsCount}}<div>',
                            columnSearch: false
                        },
                        usersCount: {
                            type: "string",
                            title: "Number of users",
                            sortable: false,
                            template: '<div class="usersDiv" data-id="{{id}}">{{usersCount}}<div>',
                            columnSearch: false
                        },
                        isDisabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        var queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&groupname=" +
                            self.groupNameRef +
                            "&hChartsIds=" +
                            self.hieChartRef +
                            "&disabledState=" +
                            self.disabledStateRef;

                        return GroupAPI.getGroups(queryString).then(result => {
                            var responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.recordsTotal;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCall = true;
                            self.tableData = responseData.data;
                            return responseData;
                        });

                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;

                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                    self.updateCall = true;
                }
            });
        },
        showDialog() {
            this.updateDialog = true;
        },
        resetForm() {
            this.filterCount = 0;
            this.updateCall = false;
            this.disabledStateRef = "active";
            this.filterDisabledState = "active";
            this.groupNameRef = "";
            this.filterGroupName = "";
            this.hieChartRef = "";
            this.hChartsIds.setSelected([])
            this.filterHieChart = "";
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initGroupsTable();
            this.updateTemplate();
        },
        closeDialog() {
            this.updateDialog = false;
        },
        showFilterDialog() {
            this.$refs.groupFilterDialog.show();
        },
        submitFilterDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.filterCount = 0;
            this.getFilterCount();
            this.groupNameRef = this.filterGroupName;
            this.hieChartRef = this.hChartsIds.getSelected();
            this.disabledStateRef = this.filterDisabledState;
            this.initGroupsTable();
            this.updateTemplate();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        updateTemplate() {
            var self = this;
            this.$refs.groupsTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        var targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            var reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/usersgroups/groups/" + reference.trim()
                            );
                        }
                    });
                });

            $(".hierarchyDiv").each((a, obj) => {
                let hieCount = $(obj)[0].innerText;
                let groupId = $(obj).attr("data-id");
                let isGroupDisabled = $(obj)
                    .closest("td")
                    .siblings()
                    .last()
                    .text();
                let htmlTag = "";

                if (isGroupDisabled == "Yes" || hieCount <= 0) {
                    htmlTag += "<span>" + hieCount + "</span>";
                    $(obj).html(htmlTag);
                } else {
                    htmlTag +=
                        "<a class='hierarchy-link' data-id=" +
                        groupId +
                        ">" +
                        hieCount +
                        "</a>";
                    $(obj).html(htmlTag);
                    $(obj)
                        .find(".hierarchy-link")
                        .on("click", function () {
                            if (this != null) {
                                self.setFilterDataInLocalStorage();
                                var groupdId = $(this).attr("data-id");
                                self.$router.push({
                                    path: self.CONTEXT_PATH +
                                        "/usersgroups/hierarchies?groupId=" +
                                        groupdId.trim()
                                });
                            }
                        });
                }
            });

            $(".usersDiv").each((a, obj) => {
                let usersCount = $(obj)[0].innerText;
                let groupId = $(obj).attr("data-id");
                let isGroupDisabled = $(obj)
                    .closest("td")
                    .siblings()
                    .last()
                    .text();
                let htmlTag = "";

                if (isGroupDisabled == "Yes" || usersCount <= 0) {
                    htmlTag += "<span>" + usersCount + "</span>";
                    $(obj).html(htmlTag);
                } else {
                    htmlTag +=
                        "<a class='users-link' data-id=" +
                        groupId +
                        ">" +
                        usersCount +
                        "</a>";
                    $(obj).html(htmlTag);
                    $(obj)
                        .find(".users-link")
                        .on("click", function () {
                            if (this != null) {
                                self.setFilterDataInLocalStorage();
                                var groupdId = $(this).attr("data-id");
                                self.$router.push({
                                    path: self.CONTEXT_PATH +
                                        "/usersgroups/users?groupId=" +
                                        groupdId.trim()
                                });
                            }
                        });
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("groupListPageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_groupName",
                this.groupNameRef
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_hChartsIds",
                this.hieChartRef
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_disabledStatus",
                this.disabledStateRef
            );
        }
    }
};
</script>
